import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59558b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label required-container"
}
const _hoisted_2 = { class: "label-right" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 1,
  class: "required-label"
}
const _hoisted_5 = {
  class: "textbox-container",
  "data-bind": "dxTextBox: {}"
}

import { PropType, computed, ref, watch } from "vue";
import { DxValidator } from "devextreme-vue";
import { DxTextBox, DxButton } from "devextreme-vue/text-box";
import { validationCallback } from "@/utils/validation/FieldValidator";
import {
  DxCustomRule,
  DxRequiredRule,
  DxEmailRule,
} from "devextreme-vue/validator";
import { FieldValidation } from "acquaint-api/validation/FieldValidation";
import { FieldSize } from "@/enums/system/FieldSize";
import { ValidatedEvent } from "devextreme/ui/validator";
import { ValidationType } from "acquaint-api/validation/ValidationType";
import { DxTooltip } from "devextreme-vue/tooltip";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { CountryCode } from "bright-logic-core/src/CountryCode";


export default /*#__PURE__*/_defineComponent({
  __name: 'acquaint-textbox',
  props: {
  /**
   * The validation rules for the input field.
   * @type {FieldValidation | undefined}
   */
  fieldValidation: {
    type: Object as PropType<FieldValidation>,
    required: true,
  },
  /**
   * The string value used with `v-model` to control the visibility or state of a modal or component.
   * @type {string}
   * @required
   */
  modelValue: {
    type: String,
    required: true,
  },
  /**
   * The width of the input field, defined by `FieldSize`.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * A custom validation function for validating the input field.
   * @type {Function | undefined}
   */
  customValidation: {
    type: Function,
    required: false,
  },
  /**
   * The message to display when validation fails.
   * @type {string | undefined}
   */
  invalidMessage: {
    type: String,
    required: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the specific input control is required.
   * @type {boolean}
   * @default false
   */
  requiredInput: {
    type: Boolean,
    default: false,
  },
  /**
   * The validation group name for form validation.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    required: false,
    default: "",
  },
  /**
   * Determines whether the control is for email.
   * @type {boolean}
   * @default false
   */
  isEmail: {
    type: Boolean,
    default: false,
  },
  /**
   * Placeholder text displayed when the input is empty.
   * @type {string}
   * @default ''
   */
  placeholderText: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to apply tooltip.
   * @type {boolean}
   * @default false
   */
  useToolTip: {
    type: Boolean,
    default: false,
  },
  /**
   * The ID of the tooltip to be applied.
   * @type {string}
   * @default ''
   */
  toolTipId: {
    type: String,
    default: "",
  },
  /**
   * The ID of the tooltip target element.
   * @type {string}
   * @default ''
   */
  toolTipTarget: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to allow reset validation.
   * @type {boolean}
   * @default false
   */
  resetValid: {
    type: Boolean,
    default: false,
  },
  /**
   * The numeric value indicating the selected option for housing development.
   * @type {number}
   * @default -1
   */
  valueChangeEvent: {
    type: String as PropType<TextboxValueChangeEvent>,
    default: TextboxValueChangeEvent.KeyUp,
  },
  /**
   * Determines whether to show the clear button.
   * @type {boolean}
   * @default false
   */
  showClearButton: {
    type: Boolean,
    default: false,
  },
  /**
   * The country code associated with the field.
   * @type {CountryCode}
   * @default CountryCode.NotSet
   */
  countryCode: {
    type: Number as PropType<CountryCode>,
    default: CountryCode.NotSet,
  },
  /**
   * Determines whether to show an asterisk (typically for required fields).
   * @type {boolean}
   * @default false
   */
  showAsterisk: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  "update:modelValue",
  "change",
  "onFocused",
  "onUnfocused",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "39fe3ea9": (props.width)
}))



const value = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val),
});

const validationErrors = ref("");
const isValid = ref(true);
const textboxModeType = ref(false);



watch(
  () => props.resetValid,
  () => {
    if (props.resetValid) {
      isValid.value = true;
      return;
    }
  },
);

/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return value.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    if (props.resetValid) {
      isValid.value = true;
      return;
    }

    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

watch(
  () => props.fieldValidation,
  () => {
    if (props.fieldValidation.validationType === ValidationType.UserPassword) {
      textboxModeType.value = true;
    }
  },
  { immediate: true },
);

const textboxMode = computed(() => {
  return textboxModeType.value ? "password" : "text";
});

const showPasswordOptions = {
  icon: "fas fa-eye",
  stylingMode: "text",
  type: "acquaint-textbox-button",
  disabled: false,
  visible: props.fieldValidation.validationType === ValidationType.UserPassword,
  onClick: () => {
    textboxModeType.value = !textboxModeType.value;
  },
};

const viewUrlOptions = {
  icon: "fas fa-external-link",
  stylingMode: "text",
  type: "acquaint-textbox-button",
  disabled: false,
  visible: props.fieldValidation.validationType === ValidationType.WebPage,
  onClick: () => redirectToUrl(),
};

const redirectToUrl = () => {
  /* If user hasn't entered a url starting with http or https, using window.open will append the url to the current domain
   * To get round this, we must first santize the url */
  if (!value.value) return;

  const url =
    value.value.startsWith("http:") || value.value.startsWith("https:")
      ? value.value
      : `https://${value.value}`;
  window.open(url);
};

const requiredMessage = computed(() =>
  props.label ? `${props.label} is required` : "This field is required",
);

/** Handles the change event of the DxTextBox.
 * Note: this fires when user leaves the component not when text changes */
const onChange = (e: any) => emit("change", e);

const onFocusOut = () => {
  value.value = value.value.trim();
  emit("onUnfocused");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(__props.label), 1),
          _createElementVNode("span", _hoisted_2, [
            (props.useToolTip)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "fas fa-info-circle info-icon",
                  id: props.toolTipId
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (
            props.showAsterisk &&
            (props.requiredInput || __props.fieldValidation.isRequired)
          )
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Required"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(DxTextBox), {
        value: value.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        "max-length": props.fieldValidation.maxLength,
        width: __props.width,
        "read-only": props.readOnly,
        isValid: isValid.value,
        hint: validationErrors.value,
        mode: textboxMode.value,
        valueChangeEvent: __props.valueChangeEvent,
        placeholder: props.placeholderText,
        onChange: onChange,
        onFocusIn: _cache[1] || (_cache[1] = ($event: any) => (emit('onFocused'))),
        onFocusOut: _cache[2] || (_cache[2] = ($event: any) => (onFocusOut()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            name: "clear-text",
            position: "after",
            options: {
            icon: 'clear',
            stylingMode: 'text',
            type: 'acquaint-textbox-button',
            visible: props.showClearButton && !props.readOnly && value.value,
            disabled: false,
            onClick: () => (value.value = ''),
          }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxButton), {
            name: "show-password",
            position: "after",
            options: showPasswordOptions
          }),
          _createVNode(_unref(DxButton), {
            name: "view-url-icon",
            position: "after",
            options: viewUrlOptions
          }),
          _createVNode(_unref(DxValidator), {
            adapter: adapterConfig,
            "validation-group": props.validationGroup
          }, {
            default: _withCtx(() => [
              (__props.fieldValidation.isRequired || props.requiredInput == true)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), {
                    key: 0,
                    message: requiredMessage.value
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (props.customValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 1,
                    reevaluate: true,
                    "validation-callback": __props.customValidation,
                    message: props.invalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(DxCustomRule), {
                fieldValidation: __props.fieldValidation,
                "validation-callback": _unref(validationCallback),
                reevaluate: true,
                countryCode: props.countryCode
              }, null, 8, ["fieldValidation", "validation-callback", "countryCode"]),
              (props.isEmail)
                ? (_openBlock(), _createBlock(_unref(DxEmailRule), { key: 2 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["validation-group"]),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["value", "max-length", "width", "read-only", "isValid", "hint", "mode", "valueChangeEvent", "placeholder"]),
      _createVNode(_unref(DxTooltip), {
        target: props.toolTipTarget,
        "show-event": "mouseenter",
        width: "275px",
        position: "top",
        "hide-event": "mouseleave"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "tooltip-content")
        ]),
        _: 3
      }, 8, ["target"])
    ])
  ]))
}
}

})